const PEDIDOS_YA_WEB_STRING_ENCODE = 'cGVkaWRvc3lhLXdlYg==';
const PEDIDOS_YA_WEB_DEV_STRING_ENCODE = 'ZGV2LXBlZGlkb3N5YS13ZWI=';
const PEDIDOS_YA_WEB_LOCAL_STRING_ENCODE = 'bG9jYWwtcGVkaWRvc3lhLXdlYg==';

module.exports = {
  PEDIDOS_YA_WEB_STRING_ENCODE,
  PEDIDOS_YA_WEB_DEV_STRING_ENCODE,
  PEDIDOS_YA_WEB_LOCAL_STRING_ENCODE,
};
